// extracted by mini-css-extract-plugin
export default {"HeaderWrapper":"Header_HeaderWrapper__xV6zr","HeaderMenuList":"Header_HeaderMenuList__ydpR5","HeaderMenuItem":"Header_HeaderMenuItem__LuSvk"};